import Layout from "@common/components/Layout";
import Assignment from "@admin/pages/Assignment";
import AssignmentMark from "@admin/pages/AssignmentMark";
import Dashboard from "@admin/pages/Dashboard";
import Login from "@common/pages/Login";
import Quizzes from "@admin/pages/Quizzes";
import Videos from "@admin/pages/Videos";

const adminRoutes = [
  {
    path: "/admin/login",
    element: <Login />,
  },
  {
    path: "/admin",
    element: <Layout />,
    routes: [
      {
        path: "/admin",
        element: <Dashboard />,
      },
      {
        path: "/admin/videos",
        element: <Videos />,
      },
      {
        path: "/admin/assignment",
        element: <Assignment />,
      },
      {
        path: "/admin/quizzes",
        element: <Quizzes />,
      },
      {
        path: "/admin/assignment-mark",
        element: <AssignmentMark />,
      },
    ],
  },
];

export default adminRoutes;
